(function () {
  "use strict";

  angular
    .module("alk.import")
    .controller("importAddressModalController", importAddressModalController);

  importAddressModalController.$inject = ["$scope", "$filter", "$uibModalInstance", "$translate", "alkModalService", "$timeout", "alkImportService"];

  function importAddressModalController($scope, $filter, $uibModalInstance, $translate, alkModalService, $timeout, alkImportService) {
    var vm = this;

    const MAX_MATCH_DISTANCE = 20;  //In KM; if input lat/lon difference from geocoded lat/lon > this distance, a warning will be shown

    vm.pageNumber = 1;
    vm.resultsPerPage = 100;
    vm.pages = [];
    vm.currentPageResults = [];
    vm.countTotalPlacesGeocoded = 0;
    vm.countTotalPlaces = 0;
    vm.qualityFilter = "all";

    var currentWizardData = alkModalService.getCurrentWizardData();
    var importFeatureType = currentWizardData.importFeatureType;
    vm.isPlacesImport = (importFeatureType === "ContentToolsPlaces");
    vm.isStopsImport = (importFeatureType === "PCMWebUIStops");
    var entityNameText;
    if(vm.isPlacesImport) entityNameText = $translate.instant("templates.locations.places");
    else if(vm.isStopsImport) entityNameText = $translate.instant("templates.importStops.stops");

    vm.geocodeResults = currentWizardData.geocodeResults;
    vm.fullGeocodeResults = vm.geocodeResults.slice(0);
    vm.skippedPlaces = currentWizardData.skippedPlaces;
    vm.importType = currentWizardData.importType;
    vm.setName = currentWizardData.setName;
    vm.headers = currentWizardData.headers;
    vm.importFunction = currentWizardData.importFunction;
    vm.inputRowsNotGeocoded = currentWizardData.inputRowsNotGeocoded;
    vm.submitted = false;
    vm.showMapPlace = null;
    vm.showMapButton = null;
    vm.noInputLatLon = noInputLatLon;

    vm.allAddressesHidden = allAddressesHidden;
    vm.getSkippedPlacesCount = getSkippedPlacesCount;
    vm.getResponseAddressStr = getResponseAddressStr;
    vm.getConfidenceStr = getConfidenceStr;
    vm.skipOrUnskipAll = skipOrUnskipAll;
    vm.showMap = showMap;
    vm.showList = showList;
    vm.finish = finish;
    vm.back = back;
    vm.cancel = cancel;
    vm.hasMatchSelected = hasMatchSelected;
    vm.shouldShowResult = shouldShowResult;
    vm.shouldShowAddressSelect = shouldShowAddressSelect;
    vm.matchAddressSelectEnabled = matchAddressSelectEnabled;
    vm.shouldShowLatLonSelect = shouldShowLatLonSelect;
    vm.inputLatLonSelectEnabled = inputLatLonSelectEnabled;
    vm.getRowTextIssue = getRowTextIssue;
    vm.updateSkippedPlaces = updateSkippedPlaces;

    vm.textFilter = "";
    vm.submitError = "";
    vm.onPageChange = onPageChange;
    vm.onFilterChange = onFilterChange;
    vm.getLatLonComparison = getLatLonComparison;
    vm.isHiddenDueToShowMap = isHiddenDueToShowMap;

    if (vm.headers.indexOf("Latitude") > -1 && vm.headers.indexOf("Longitude") > -1) {
      vm.hasLatLon = true;
      // numbers should add up to 12 (bootstrap)
      vm.columnWidths = ["col-xs-1", "col-xs-1", "col-xs-3", "col-xs-3", "col-xs-2", "col-xs-2"];
    } else {
      vm.hasLatLon = false;
      // numbers should add up to 12 (bootstrap)
      vm.columnWidths = ["col-xs-1", "col-xs-1", "col-xs-3", "col-xs-3", "", "col-xs-3"];
    }

    vm.totalCountMessage = $translate.instant("common.import.addressTotalEntities", { importEntity: entityNameText });
    vm.geocodedCountMessage = $translate.instant("common.import.addressGeocodedEntities", { importEntity: entityNameText });
    vm.matchedCountMessage = $translate.instant("common.import.addressMatchedEntities", { importEntity: entityNameText });
    vm.failedCountMessage = $translate.instant("common.import.addressFailedEntities", { importEntity: entityNameText });

    init();

    ////////////////

    function init() {
      chunkVisibleResults();

      vm.countTotalPlaces = vm.geocodeResults.length + vm.inputRowsNotGeocoded.length;
      vm.countTotalPlacesGeocoded = vm.geocodeResults.length;
      for (let i = 0; i < vm.geocodeResults.length; i++) {
        var result = vm.geocodeResults[i];
        result.index = i;
        result.disabled = false;

        if(!result.ConfidenceLevel) {
          result.ConfidenceLevel = "Failed";
          result.Coords = null;
          result.Address = null;
        }

        if(noInputLatLon(result) || nullInputLatLon(result)) {
          if (result.ConfidenceLevel === "Failed") {
            result.disabled = true;
          } else {
            result.useInputLatLon = false;
          }
        } else if (!result.disabled) {
          result.useInputLatLon = true;
        }

        if(getLatLonDistance(result) > MAX_MATCH_DISTANCE) {
          result.latlonMismatch = true;
        }

        if (result.Coords && result.Coords.Lon && result.Coords.Lat && result.inputRow.YardPoints &&
          !alkImportService.strContainsLonLat(result.inputRow.YardPoints, result.Coords.Lon, result.Coords.Lat)) {
          if(vm.noInputLatLon(result) || nullInputLatLon(result)) {
            result.disabled = true;
            result.badSiteCoords = true;
            result.useInputLatLon = undefined;
          } else {
            //We can't select match address since it doesn't fall within site coordinates. We need to disable it.
            result.badMatchAddressCoords = true;
          }
        }

        result.skipped = result.disabled;
      }
      if (vm.skippedPlaces)
        updateSkippedPlaces();
    }

    function noInputLatLon(result) {
      return !result.inputRow.Latitude || !result.inputRow.Longitude;
    }

    function nullInputLatLon(result) {
      return result.inputRow.Latitude == 0 && result.inputRow.Longitude == 0;
    }

    //Get distance from input lat/lon in KM
    function getLatLonDistance(result) {

      if (noInputLatLon(result) || nullInputLatLon(result)) {
        return -1;
      }
      if (!result.Coords || result.Coords.Lon == null || result.Coords.Lat == null) {
        return -1;
      }

      var userProvidedLatLonGeom = new ALKMaps.Geometry.Point(result.inputRow.Longitude, result.inputRow.Latitude);
      var geocodedLatLonGeom = new ALKMaps.Geometry.Point(result.Coords.Lon, result.Coords.Lat);

      var line = new ALKMaps.Geometry.LineString([userProvidedLatLonGeom, geocodedLatLonGeom]);
      var distance = line.getGeodesicLength(new ALKMaps.Projection("EPSG:4326"));
      distance *= 0.001; //m to km
      return distance;
    }

    //Get lat/lon comparison string
    function getLatLonComparison(result) {
      //No input lat lon at all: tell the user it wasn't provided
      if (noInputLatLon(result)) {
        return $translate.instant("common.import.latLonNotProvided");
      }
      if (nullInputLatLon(result)) {
        return $translate.instant("common.import.nullLatLonProvided");
      }

      //Input lat lon but geocoding failed: don't show the "miles away" message
      var latLonStr = Number(result.inputRow.Latitude).toFixed(4) + ", " + Number(result.inputRow.Longitude).toFixed(4);
      if (!result.Coords || result.Coords.Lon == null || result.Coords.Lat == null) {
        return latLonStr + "<br/>" + $translate.instant("common.import.latLonNotGeocoded");
      }

      var translateKey = "common.import.addressKmDistance";
      var distance = getLatLonDistance(result);

      if ($translate.use() === "en_US") {
        translateKey = "common.import.addressMilesDistance";
        distance *= 0.621371; //Convert KM to miles
      }

      return latLonStr + "<br/>" +
        $translate.instant(translateKey, {
          distance: distance.toFixed(2)
        });
    }

    function chunkVisibleResults() {
      vm.pageNumber = 1;
      vm.pages = chunk(vm.geocodeResults, vm.resultsPerPage);
      onPageChange();
    }

    function chunk(arr, chunkSize) {
      var groups = [], i;
      for (i = 0; i < arr.length; i += chunkSize) {
          groups.push(arr.slice(i, i + chunkSize));
      }
      return groups;
    }

    function onPageChange() {
      angular.element("#resultsScrollDiv").scrollTop(0);
      vm.currentPageResults = vm.pages[vm.pageNumber - 1];
    }

    function getSkippedPlacesCount() {
      var count = 0;
      _.each(vm.fullGeocodeResults, function (result) {
        if (result.disabled || result.skipped) {
          count++;
        }
      });
      count+=(vm.countTotalPlaces-vm.countTotalPlacesGeocoded); // add unprocessed stops
      return count;
    }

    function skipOrUnskipAll(skip) {
      _.each(vm.geocodeResults, function (result) {
        if (!result.disabled) {
          result.skipped = skip;
        }
      });
    }

    function showMap(result, event) {
      if (!vm.showMapPlace) {
        vm.showMapPlace = result;
        vm.showMapButton = event.target;

        var locationObj;
        if(result.useInputLatLon) {
          locationObj = {
            Coords: {
              Lat: result.inputRow.Latitude,
              Lon: result.inputRow.Longitude
            },
            Address: {}
          };
        } else {
          locationObj = result;
        }

        currentWizardData.onShowMap(locationObj);
      }
    }

    function showList() {
      $timeout(function () {
        vm.showMapButton.blur();
        vm.showMapButton.focus();
      }, 0);
      vm.showMapPlace = null;
      currentWizardData.onShowList();
    }

    function getConfidenceStr(responseConfidenceStr) {
      if (responseConfidenceStr === "Exact") {
        return $translate.instant("common.import.confidenceLevelExact");
      } else if (responseConfidenceStr === "Good") {
        return $translate.instant("common.import.confidenceLevelGood");
      } else if (responseConfidenceStr === "Uncertain") {
        return $translate.instant("common.import.confidenceLevelUncertain");
      } else {
        return $translate.instant("common.import.confidenceLevelFailed");
      }
    }

    function allAddressesHidden() {
      for (var i = 0; i < vm.geocodeResults.length; i++) {
        if (shouldShowResult(vm.geocodeResults[i])) {
          return false;
        }
      }
      return true;
    }

    function onFilterChange() {
      vm.geocodeResults = [];
      _.each(vm.fullGeocodeResults, function (result) {
        if (shouldShowResult(result)) {
          vm.geocodeResults.push(result);
        }
      });
      chunkVisibleResults();
    }

    function isHiddenDueToShowMap(result) {
      if (vm.showMapPlace && vm.showMapPlace !== result) {
        return true;
      }
      return false;
    }

    function shouldShowResult(result) {
      if (vm.textFilter !== "") {
        var reqAddr = result.requestAddressStr.toLowerCase();
        var respAddr = vm.getResponseAddressStr(result).toLowerCase();
        if (!reqAddr.includes(vm.textFilter.toLowerCase()) && !respAddr.includes(vm.textFilter.toLowerCase())) {
          return false;
        }
      }
      if (vm.qualityFilter !== "all") {
        if (vm.qualityFilter === "exact" && result.ConfidenceLevel !== "Exact") {
          return false;
        } else if (vm.qualityFilter === "good" && result.ConfidenceLevel !== "Good") {
          return false;
        } else if (vm.qualityFilter === "uncertain" && result.ConfidenceLevel !== "Uncertain") {
          return false;
        } else if (vm.qualityFilter === "skipped" && result.ConfidenceLevel !== "Failed") {
          return false;
        }
      }
      return true;
    }

    function getResponseAddressStr(result) {
      if (result.disabled && !result.badSiteCoords) {
        return "";
      }
      if (!result.Address) {
        return "";
      }
      // pchen: maybe we should change the filter to use StateAbbreviation instead?
      result.Address.State = result.Address.StateAbbreviation;
      return String($filter("fullAddressFilter")(result.Address, false));
    }

    function hasMatchSelected() {
      //If there are non-geocoded entries, we should always be able to submit
      if(vm.inputRowsNotGeocoded.length > 0) {
        return true;
      }
      for (var i = 0; i < vm.fullGeocodeResults.length; i++) {
        if (!vm.fullGeocodeResults[i].skipped && !vm.fullGeocodeResults[i].disabled) {
          return true;
        }
      }
      return false;
    }

    function shouldShowAddressSelect(result) {
      return vm.hasLatLon;
    }

    function matchAddressSelectEnabled(result) {
      return shouldShowAddressSelect(result) && !result.disabled && result.ConfidenceLevel !== "Failed" && !result.badMatchAddressCoords;
    }

    function shouldShowLatLonSelect(result) {
      return vm.hasLatLon;
    }

    function inputLatLonSelectEnabled(result) {
      return shouldShowLatLonSelect(result) && !result.disabled && !noInputLatLon(result) && !nullInputLatLon(result);
    }

    function getRowTextIssue(result) {
      if(result.badSiteCoords) {
        //This can only happen in places import. Won't translate if not reached
        return $translate.instant("templates.importPlaces.matchAddressNotInSiteCoords");
      } else if(result.latlonMismatch) {
        return $translate.instant("common.import.addressLatLonMismatch");
      }
    }

    function updateSkippedPlaces() {
      vm.skippedPlaces.forEach(function (index) {
        vm.fullGeocodeResults[index].skipped = true;
      });
    }
    function finish() {

      if (vm.submitted) return;
      vm.submitted = true;

      var inputRowsToCreate = [];
      vm.skippedPlaces = [];
      vm.fullGeocodeResults.forEach(function (result, index) {
        if (result.skipped || result.disabled) {
          vm.skippedPlaces.push(index);
          return;
        }

        var inputRow = angular.copy(result.inputRow); //Copy so that the UI doesn't suddenly change briefly when submit is clicked

        //Update input row to create to the new address fields
        //Use geocoded lat lons if not provided
        if(noInputLatLon(result) || !result.useInputLatLon) {
          inputRow.Latitude = result.Coords.Lat;
          inputRow.Longitude = result.Coords.Lon;
        }

        //If a geocoded address was found, use the geocoded address values ONLY if the user didn't provide their own for each specific field
        if(result.Address) {
          if(!inputRow.StreetAddress && result.Address.StreetAddress) {
            inputRow.StreetAddress = result.Address.StreetAddress;
          }
          if(!inputRow.City && result.Address.City) {
            inputRow.City = result.Address.City;
          }
          if(!inputRow.State && result.Address.StateAbbreviation) {
            inputRow.State = result.Address.StateAbbreviation;
          }
          if(!inputRow.Zip && result.Address.Zip) {
            inputRow.Zip = result.Address.Zip;
          }
          if(!inputRow.County && result.Address.County) {
            inputRow.County = result.Address.County;
          }
          if(!inputRow.Country && result.Address.Country) {
            inputRow.Country = result.Address.Country;
          }
        }
        inputRowsToCreate.push(inputRow);
      });
      currentWizardData.skippedPlaces = vm.skippedPlaces;
      inputRowsToCreate = inputRowsToCreate.concat(vm.inputRowsNotGeocoded);
      currentWizardData.inputRowsToCreate = inputRowsToCreate; //save data to currentwizard instead of importfunction
      $uibModalInstance.close({});
    }

    function back() {
      vm.skippedPlaces = [];
      vm.fullGeocodeResults.forEach(function (result, index) {
        if (result.skipped || result.disabled) {
          vm.skippedPlaces.push(index);
          return;
        }
      });
      currentWizardData.skippedPlaces = vm.skippedPlaces;
      $uibModalInstance.close({
        back: true
      });
    }

    function cancel() {
      $uibModalInstance.dismiss();
    }

  }
})();



// WEBPACK FOOTER //
// ./Common Javascript Files/AngularJS/alk-import/importAddressModal.controller.js